import { hideEmbeddedContainer, playNotification } from '../../utils/sf-utils/helper';
import { trackEvent } from '../../utils/app-utils/event-utils';
import {
  onBackButtonClick,
  onButtonClick,
  onChatEndedByUser,
  onChatEstablished,
  onChatReady,
  onChatTransfer,
  onMaximize,
  onMessageSent,
  onMinimize,
  onSessionContinuation,
  getSchedule,
} from './sf-event-handlers';
import { logNR } from '../../utils/app-utils/nr-logging';
import { updateFloatingButtonText, updateButtonUnreadCount } from '../../utils/button-utils/custom-button-utils';
import { IUserInfo } from '../../utils/api-utils/user-profile-api';
import { WindowType } from '../../types/global-window-type';
import { setAdditionalInfo, setHiddenPrechatFields } from '../../utils/sf-utils/chat-init';
import { checkBusinessHours } from '../../utils/api-utils/gcp-api';
import { t } from '../../utils/app-utils/translations';
import { getChatConfig } from '../../utils/app-utils/chat-config-utils';
import { enableEnhancedPreChat } from '../../utils/app-utils/page-specific-utils';

declare const window: WindowType;

export const addChatEventListeners = (context, userInfo?: IUserInfo) => {
  try {
    const { finalContext: contextData, additionalProperties } = context;
    let timeAtBusinessHourApi = 0;
    let timeRemaining = 0;
    let isChatEnabled = true;
    let scheduleHours;

    /** Wrapper Fn to take out all common attributes for chat event */
    const trackChatEvent = (data: { label: string; eventDetail: string }) => {
      const { eventDetail, label } = data;
      trackEvent('Chat Initiated', {
        category: 'Global Chat',
        label,
        eventDetail,
        pageName: contextData.pageName.value || 'Others',
        pageSection: contextData.pageSection.value || 'Others',
        pageStage: contextData.pageStage.value || 'Others',
      });
    };

    checkBusinessHours()
      .then(async (data) => {
        // TODO:: we are going to call it here
        timeRemaining = data.status.remainingTime;
        timeAtBusinessHourApi = Date.now();
        isChatEnabled = data.status.isChatEnabled;
        scheduleHours = getSchedule(data.formattedBusinessHours, data.timezone.name, getChatConfig().locale);
        console.info('onEmbeddedMessageSent checkBusinessHours', data, timeRemaining, timeAtBusinessHourApi);
        console.info(
          'onEmbeddedMessageSent checkBusinessHours',
          scheduleHours,
          data.timezone.name || 'Asia/Singapore',
          getChatConfig().locale,
        );
      })
      .catch((error) => {
        const e = error as Error;
        console.error('Error in CA init', e);
        logNR('CA_ERROR', { errorMessage: e.message, errorStack: e.stack });
      });
    /**
     * Fires when the Salesforce JavaScript API for Messaging is ready to use.
     */
    window.addEventListener('onEmbeddedMessagingReady', () => {
      /** Set all fields obtained from context */
      setHiddenPrechatFields(contextData, userInfo, additionalProperties);

      /** Set user Information if user is logged in , enhanched pre-chat info */
      setAdditionalInfo(userInfo);

      onChatReady();
    });

    window.addEventListener('onEmbeddedMessageSent', ((e: CustomEvent) => {
      console.info('onEmbeddedMessageSent RAW', e.detail);

      const entry = e.detail?.conversationEntry;
      if (!entry) return;

      // Parse the entryPayload string to object
      let payloadObj;
      try {
        payloadObj = JSON.parse(entry.entryPayload);
      } catch (err) {
        console.error('Failed to parse entryPayload onEmbeddedMessageSent:', err);
        return;
      }

      const senderName = entry.senderDisplayName;
      const formatType = payloadObj?.abstractMessage?.staticContent?.formatType;
      const text = payloadObj?.abstractMessage?.staticContent?.text;
      const conversationIdentifier = e?.detail?.conversationId;
      console.info('onEmbeddedMessageSent entry', entry);
      console.info('onEmbeddedMessageSent conversationIdentifier', conversationIdentifier);
      // Validate the specific message
      try {
        if (
          senderName === 'Automated Process' &&
          formatType === 'Text' &&
          text === 'The conversation ended.\nType your message to resume the conversation.'
        ) {
          const headerContainer = document.getElementById('embeddedMessagingFrame') as HTMLIFrameElement;
          console.info('onEmbeddedMessageSent Targeting iframe:', headerContainer);
          if (headerContainer?.contentWindow) {
            console.info('Dispatching MessageSent to iframe');
            headerContainer.contentWindow.postMessage({ eventType: 'MessageSent', conversationIdentifier }, '*');
          }
        }
      } catch (error) {
        console.error('onEmbeddedMessageSent Error iframe:', error);
      }
    }) as EventListener);

    window.addEventListener('message', (event) => {
      if (event.data.type === 'customHeaderbackButtonClick') {
        console.info('Handling customHeaderbackButtonClick:');
        onBackButtonClick();
      }
      if (event.data.type === 'chatEndMIAWEvent') {
        console.info('Handling Chat End');
        onChatEndedByUser();
      }
      if (event.data.type === 'chatPrechatLoadedMIAW') {
        console.info('chatPrechatLoadedMIAW');
        const timeForBH = timeRemaining * 1000 + timeAtBusinessHourApi;
        const isPreChatLoadedOOBHMIAW = isChatEnabled ? Date.now() > timeForBH : Date.now() < timeForBH;
        if (isPreChatLoadedOOBHMIAW) {
          setTimeout(() => {
            const headerContainer = document.getElementById('embeddedMessagingFrame') as HTMLIFrameElement;
            console.info('chatPrechatLoadedMIAW Targeting iframe:');
            if (headerContainer?.contentWindow) {
              console.info('Dispatching chatPrechatLoadedMIAW to headerContainer');
              headerContainer.contentWindow.postMessage({ eventType: 'preChatLoadedOOBHMIAW', scheduleHours }, '*');
            }
          }, 1);
        }
      }
    });

    window.addEventListener('onEmbeddedMessageSent', ((e: CustomEvent) => {
      console.info('onEmbeddedMessageSent RAW', e.detail);
      const entry = e.detail?.conversationEntry;
      const timeForBH = timeRemaining * 1000 + timeAtBusinessHourApi;
      if (!entry) return;
      const isCustMsgNotAllowed = isChatEnabled ? Date.now() > timeForBH : Date.now() < timeForBH;
      if (isCustMsgNotAllowed) {
        console.info('onEmbeddedMessageSent inside here ');
        const senderName = entry.senderDisplayName;
        const recordId = entry?.relatedRecords[0];
        try {
          if (senderName === 'Guest') {
            const headerContainer = document.getElementById('embeddedMessagingFrame') as HTMLIFrameElement;
            if (headerContainer?.contentWindow) {
              headerContainer.contentWindow.postMessage({ eventType: 'MessageSent', recordId, scheduleHours }, '*');
            }
          }
        } catch (error) {
          console.error('onEmbeddedMessageSent Error iframe:', error);
        }
      }
    }) as EventListener);

    /**
     * Fires the first time the chat button is clicked by the end user.
     */
    window.addEventListener('onEmbeddedMessagingButtonClicked', () => {
      console.info('onEmbeddedMessagingButtonClicked');
      trackChatEvent({
        label: 'Chat help initiated - Chat Anywhere',
        eventDetail: `${contextData.pagePath.value || ''};Chat Initiate`,
      });
      onButtonClick();
    });

    /**
     * Fires when the messaging conversation window is maximized.
     */
    window.addEventListener('onEmbeddedMessagingWindowMaximized', () => {
      console.info('onEmbeddedMessagingWindowMaximized');
      onMaximize();

      const currentUrl = window.location.href;
      const currentPath = window.location.origin + window.location.pathname;
      const storedUrl = sessionStorage.getItem('miaw_current_page');
      const conversationId = sessionStorage.getItem('miaw_conversation_id');

      if (storedUrl !== currentUrl && conversationId) {
        sessionStorage.setItem('miaw_current_page', currentUrl);
        console.info('PageChanged');

        const headerContainer = document.getElementById('embeddedMessagingFrame') as HTMLIFrameElement;

        if (headerContainer) {
          // Dispatch the event on the header container
          headerContainer.contentWindow?.postMessage(
            { eventType: 'PageChanged', currentUrl, currentPath, conversationId },
            '*',
          );
        }
      }
    });

    /**
     * Fires when the messaging conversation window is minimized.
     */
    window.addEventListener('onEmbeddedMessagingWindowMinimized', () => {
      console.info('onEmbeddedMessagingWindowMinimized');
      hideEmbeddedContainer();
      onMinimize();
    });

    /**
     * Fires when a messaging conversation starts. This event only applies to the browser tab where the conversation was created.
     */
    window.addEventListener('onEmbeddedMessagingConversationCreated', (event) => {
      console.info('onEmbeddedMessagingConversationCreated');
      console.info('Event detail: ', { event });
      onChatEstablished();
      logNR('CA_CHAT_REQUEST_SUCCESS');
    });

    /**
     * Fires when a messaging conversation is loaded into a browser tab,
     * whether it moved to a new browser tab or was loaded in the browser tab where the conversation started.
     */
    window.addEventListener('onEmbeddedMessagingConversationOpened', () => {
      console.info('onEmbeddedMessagingConversationOpened');
      updateFloatingButtonText(t('Connecting'));
      onSessionContinuation();
    });

    /**
     * Fires when a messaging conversation is routed or manually transferred from one internal recipient to another,
     *  such as from a bot to an agent. This event also fires if the routing or manual transfer is unsuccessful.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.addEventListener('onEmbeddedMessagingConversationRouted', (event: any) => {
      console.info('onEmbeddedMessagingConversationRouted');
      console.info('Event detail: ', { event });
      trackChatEvent({
        label: 'Chat opened - Chat Anywhere',
        eventDetail: `${contextData.pagePath.value || ''};Chat Start`,
      });
      logNR('CA_CHAT_ESTABLISHED');
      sessionStorage.setItem('miaw_conversation_id', event?.detail?.conversationId);
      // TODO:: here
      if (enableEnhancedPreChat()) {
        const headerContainer = document.getElementById('embeddedMessagingFrame') as HTMLIFrameElement;
        if (headerContainer) {
          // Dispatch the event on the header container
          headerContainer.contentWindow?.postMessage(
            {
              eventType: 'enhancedPrechatSelected',
              conversationId: event?.detail?.conversationId,
              accessToken: userInfo?.userToken,
            },
            '*',
          );
        }
      }
      onChatTransfer();
    });

    /**
     * Fires when a messaging conversation starts.
     * This event only applies to the browser tab where the conversation was created.
     */
    window.addEventListener('onEmbeddedMessagingConversationStarted', () => {
      console.info('onEmbeddedMessagingConversationStarted');
      logNR('CA_CHAT_REQUEST_SUCCESS');
    });

    /**
     * Fires when a new internal user, such as a bot or an agent, joins a conversation. Or, when an existing internal user leaves a conversation.
     */
    window.addEventListener('onEmbeddedMessagingConversationParticipantChanged', (event) => {
      console.info('onEmbeddedMessagingConversationParticipantChanged');
      sessionStorage.setItem('AgentName', '');
      console.info('Event detail: ', { event });

      const orderHelpDescription = sessionStorage.getItem('miaw_order_help_description');
      const conversationId = sessionStorage.getItem('miaw_conversation_id');

      if (conversationId) {
        const headerContainer = document.getElementById('embeddedMessagingFrame') as HTMLIFrameElement;

        if (headerContainer && orderHelpDescription) {
          // Dispatch the event on the header container
          headerContainer.contentWindow?.postMessage(
            { eventType: 'OrderHelpDescription', description: orderHelpDescription, conversationId },
            '*',
          );
        }
      }
    });

    /**
     * Fires when the pre-chat form is displayed to the end user.
     */
    window.addEventListener('onEmbeddedMessagingPreChatLoaded', (event) => {
      console.info('onEmbeddedMessagingPreChatLoaded');
      sessionStorage.setItem('AgentName', '');
      console.info('Event detail: ', { event });
    });

    /**
     * Fires when the end user submits the pre-chat form.
     */
    window.addEventListener('onEmbeddedMessagingPreChatSubmitted', (event) => {
      console.info('onEmbeddedMessagingPreChatSubmitted');
      sessionStorage.setItem('AgentName', '');
      console.info('Event detail: ', { event });
    });

    /**
     * Fires when an agent, a bot, or an end user sends a message.
     * The message can be typed manually or sent in the form of a messaging component.
     * This event also fires when an end user clicks on a messaging component, resulting in a second messaging component being sent.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.addEventListener('onEmbeddedMessageSent', (event: any) => {
      console.info('onEmbeddedMessageSent');
      console.info('Event detail: ', { event });
      if (window.isChatMinimized) {
        let counter = parseInt(sessionStorage.getItem('MessageCountWhenMinimized') || '0', 10);
        counter += 1;
        updateFloatingButtonText(`${counter} ${counter > 1 ? t('Messages') : t('Message')}`);
        sessionStorage.setItem('MessageCountWhenMinimized', counter.toString());
        //
        updateButtonUnreadCount(counter.toString(), true);
      } else {
        sessionStorage.setItem('MessageCountWhenMinimized', '0');
        updateButtonUnreadCount('0', false);
      }
      const isAgent = { event }?.event?.detail?.conversationEntry?.sender?.role === 'Agent';
      if (isAgent) {
        sessionStorage.setItem(
          'AgentName',
          { event }?.event?.detail?.conversationEntry?.senderDisplayName || 'Specialist',
        );
        playNotification();
      }
      // TODO update to only user messages
      trackChatEvent({
        label: 'Chat submitted - Chat Anywhere',
        eventDetail: `${contextData.pagePath.value || ''};Chat Submit`,
      });
      onMessageSent();
    });

    /**
     * Fires when an end user receives a delivery receipt. Delivery receipts must be enabled in Setup.
     */
    window.addEventListener('onEmbeddedMessageDelivered', (event) => {
      console.info('onEmbeddedMessageDelivered');
      console.info('Event detail: ', { event });
    });

    /**
     * Fires when an end user receives a read receipt. Read receipts must be enabled in Setup.
     */
    window.addEventListener('onEmbeddedMessageRead', (event) => {
      console.info('onEmbeddedMessageRead');
      console.info('Event detail: ', { event });
    });

    /**
     * Fires when an end user requests a transcript of their messaging conversation history.
     */
    window.addEventListener('onEmbeddedMessagingTranscriptRequested', (event) => {
      console.info('onEmbeddedMessagingTranscriptRequested');
      console.info('Event detail: ', { event });
    });
    /**
     * Fires when the transcript request fails.
     */
    window.addEventListener('onEmbeddedMessagingTranscriptRequestFailed', (event) => {
      console.info('onEmbeddedMessagingTranscriptRequestFailed');
      console.info('Event detail: ', { event });
    });
    /**
     * Fires when the messaging conversation transcript is successfully downloaded.
     */
    window.addEventListener('onEmbeddedMessagingTranscriptDownloadSuccessful', (event) => {
      console.info('onEmbeddedMessagingTranscriptDownloadSuccessful');
      console.info('Event detail: ', { event });
    });
    /**
     * Fires when an end user closes the messaging conversation.
     */
    window.addEventListener('onEmbeddedMessagingConversationClosed', (event) => {
      console.info('onEmbeddedMessagingConversationClosed');
      console.info('Event detail: ', { event });
      sessionStorage.setItem('AgentName', '');
      sessionStorage.setItem('isConversationBrowserClosed', 'true');
      // Update the floating button text to indicate chat ended
      updateFloatingButtonText(t('ChatEnded'));
      sessionStorage.removeItem('miaw_conversation_id');
      sessionStorage.removeItem('miaw_order_help_description');
      sessionStorage.setItem('AgentName', '');
      onChatEndedByUser();
      logNR('CA_CHAT_ENDED_BY_USER');
    });
    /**
     * The client dispatches the onEmbeddedMessagingIdentityTokenExpired event when you interact with the client
     * after both the Salesforce authorization token and identity token have expired.
     */
    window.addEventListener('onEmbeddedMessagingIdentityTokenExpired', () => {
      console.info('onEmbeddedMessagingIdentityTokenExpired');
    });
  } catch (err) {
    const e = err as Error;
    console.error('Error in addChatEventListeners', e);
    logNR('CA_EVENTS_ERROR', { errorMessage: e.message, errorStack: e.stack });
  }
};
